export const POPULATE_STUDENT_SEARCH_FILTERS =
  'POPULATE_STUDENT_SEARCH_FILTERS';

export const POPULATE_STUDENT_SEARCH_DISTRICT_INFO =
  'POPULATE_STUDENT_SEARCH_DISTRICT_INFO';

export const SET_STUDENT_SEARCH_SEARCH_FILTERS =
  'SET_STUDENT_SEARCH_SEARCH_FILTERS';

export const UPDATE_STUDENT_SEARCH_BUSY_RETRIEVING_STUDENTS =
  'UPDATE_STUDENT_SEARCH_BUSY_RETRIEVING_STUDENTS';

export const POPULATE_STUDENT_SEARCH_RESULTS =
  'POPULATE_STUDENT_SEARCH_RESULTS';

export const CHANGE_STUDENT_SEARCH_PAGE = 'CHANGE_STUDENT_SEARCH_PAGE';

export const CHANGE_STUDENT_SEARCH_STUDENTS_PER_PAGE =
  'CHANGE_STUDENT_SEARCH_STUDENTS_PER_PAGE';

export const CHANGE_STUDENT_SEARCH_SORT_MODE =
  'CHANGE_STUDENT_SEARCH_SORT_MODE';

export const CHANGE_STUDENT_SEARCH_TERM = 'CHANGE_STUDENT_SEARCH_TERM';
